const LdapIcon = ({ width, height, color = "var(--text-color-card)" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg">
      <defs></defs>
      {/* LDAP Directory Structure */}
      <rect
        fill={color}
        x="8"
        y="6"
        width="32"
        height="4"
        rx="2"
        opacity="0.8"
      />
      <rect
        fill={color}
        x="8"
        y="14"
        width="24"
        height="4"
        rx="2"
        opacity="0.6"
      />
      <rect
        fill={color}
        x="8"
        y="22"
        width="20"
        height="4"
        rx="2"
        opacity="0.4"
      />
      <rect
        fill={color}
        x="8"
        y="30"
        width="16"
        height="4"
        rx="2"
        opacity="0.3"
      />
      
      {/* Connection Lines */}
      <line
        stroke={color}
        strokeWidth="2"
        x1="24"
        y1="10"
        x2="24"
        y2="14"
      />
      <line
        stroke={color}
        strokeWidth="2"
        x1="20"
        y1="18"
        x2="20"
        y2="22"
      />
      <line
        stroke={color}
        strokeWidth="2"
        x1="18"
        y1="26"
        x2="18"
        y2="30"
      />
      
      {/* Server/Client Connection */}
      <circle
        fill={color}
        cx="36"
        cy="24"
        r="4"
      />
      <line
        stroke={color}
        strokeWidth="2"
        x1="32"
        y1="24"
        x2="28"
        y2="24"
      />
    </svg>
  );
};

export default LdapIcon; 